module.exports = __webpack_public_path__ + "static/media/soundcloud.8e9a5651.svg";